module.exports = __webpack_public_path__ + "img/3-4.16a17bbe.png";